import { render, staticRenderFns } from "./MMP_InactivityWarning.vue?vue&type=template&id=7c1d9cfe&"
import script from "./MMP_InactivityWarning.vue?vue&type=script&lang=js&"
export * from "./MMP_InactivityWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports